import React from 'react';
import PropTypes from 'prop-types';

const FilterBtn = ({ toggle, label }) => (
  <button
    type='button'
    className='bra-btnIcon bra-btnIcon--filter bra-btnIcon--reverse bra-btnIcon--text'
    onClick={toggle}
  >
    <span className='bra-btnIcon__wrap'>
      <i className='bra-icn bra-icn__filter' />
    </span>
    <span className='bra-btnIcon__text'>{label}</span>
  </button>
);

FilterBtn.propTypes = {
  toggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
};

export default FilterBtn;
